import type { QueryClient } from '@tanstack/react-query';
import type { PartnerRow } from '../services/partnerUserService';

type PartnersListCache = { data?: PartnerRow[]; total?: number };

export function extractWalletBalance(wallet: unknown): number | null {
  if (!wallet || typeof wallet !== 'object') return null;
  const balance = (wallet as { balance?: unknown }).balance;
  return typeof balance === 'number' && Number.isFinite(balance) ? balance : null;
}

/** Keep partner list wallet column in sync with the latest backend balance. */
export function patchPartnerWalletBalanceInCache(
  queryClient: QueryClient,
  partnerId: string,
  balance: number,
) {
  queryClient.setQueriesData<PartnersListCache>({ queryKey: ['partners'] }, (old) => {
    if (!old?.data?.length) return old;
    return {
      ...old,
      data: old.data.map((row) => (
        row._id === partnerId ? { ...row, walletBalance: balance } : row
      )),
    };
  });
}

export function createPartnerWalletAdjustHandler(queryClient: QueryClient) {
  return (wallet: unknown, variables: { id: string }) => {
    const balance = extractWalletBalance(wallet);
    if (balance != null) {
      patchPartnerWalletBalanceInCache(queryClient, variables.id, balance);
    }
    void queryClient.invalidateQueries({ queryKey: ['partners'] });
    void queryClient.invalidateQueries({ queryKey: ['partner-me'] });
    void queryClient.invalidateQueries({ queryKey: ['partner-god-view'] });
    void queryClient.invalidateQueries({ queryKey: ['partner-wallet-txs'] });
    void queryClient.invalidateQueries({ queryKey: ['my-wallet'] });
    void queryClient.invalidateQueries({ queryKey: ['wallet'] });
  };
}
